import cfiLogic from '../../cfiLogic';

/**
 * @method getCfiForWordOffset
 * Transforms a word range into a cfi
 *
 * @param {Object} bookDocumentInformation the result of getDocumentInformation
 * @param {Array} wordOffset the word offset for the given location
 * @returns {string} the cfi calculated for that word offset
 */
const getCfiForWordOffset = (bookDocumentInformation, wordOffset) => {
  if (!bookDocumentInformation || !wordOffset) {
    return;
  }

  const { wordObjects, frameDocument } = bookDocumentInformation;
  const wordOffsetTermStart = wordOffset[0];
  const wordOffsetTermEnd = wordOffset[1];
  const range = frameDocument.createRange();
  // Ensure the start node is a real node or use its parent element.
  let startNode = wordObjects[wordOffsetTermStart].primaryNode;
  const startNodeOffset =
    wordObjects[wordOffsetTermStart].characterOffsetInNode;
  const endNodeOffset =
    wordObjects[wordOffsetTermStart].wordText.length + startNodeOffset;
  if (!startNode.nodeType) {
    startNode = startNode.parentElement;
  }

  // Ensure the end node is a real node or use its parent element.
  let endNode = wordObjects[wordOffsetTermEnd].primaryNode;
  if (!endNode.nodeType) {
    endNode = endNode.parentElement;
  }

  range.setStart(startNode, startNodeOffset);
  range.setEnd(endNode, endNodeOffset);
  const cfi = cfiLogic.getCfiForRange(frameDocument, range);
  return cfi;
};

export default getCfiForWordOffset;
